import { updateMoneySI } from '../../slices/coverDetails';
import { AppDispatch } from '../../store';
import { Risk } from '../../types/policy';
import { RiskDetailBPKTheftMoneyGlass } from '../../types/risk';

export const updateMoneyDetailsCoverAction = ({
  risk,
  dispatch,
}: {
  risk: Risk | undefined;
  dispatch: AppDispatch;
}) => {
  const theftMoneyGlassRiskDetails = (risk?.riskDetail as RiskDetailBPKTheftMoneyGlass | undefined)
    ?.riskBPKTheftMoneyGlass;
  const { money: moneyDetails } = theftMoneyGlassRiskDetails ?? {};
  const { blanketCoverSI } = moneyDetails!;

  blanketCoverSI && dispatch(updateMoneySI(blanketCoverSI));
};
